import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import { primaryWithOpacity, primaryShadow, primary, gold } from '../../assets/colors.js';
import { zindexModalBackground, zindexModal } from '../../assets/zindex.js';
import { CancelIcon } from '../Icons/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var Overlay = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: all 0.2s ease-in-out;\n  z-index: ", ";\n  pointer-events: ", ";\n  display: block;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: ", ";\n"])), function (props) {
  return props.open && "1" || "0";
}, zindexModalBackground, function (props) {
  return props.open && "all" || "none";
}, primaryWithOpacity);
var Side = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-shadow: 0 5px 10px 0 ", ";\n  background-color: ", ";\n  position: fixed;\n  display: block !important;\n  z-index: ", ";\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 315px;\n  height: 100vh;\n  transform: ", ";\n  transition: transform 0.2s ease-in-out;\n  overflow: scroll;\n  -webkit-overflow-scrolling: touch;\n"])), primaryShadow, primary, zindexModal, function (props) {
  return props.open && "translateX(0px)" || "translateX(340px)";
});
var SideClose = styled(CancelIcon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  object-fit: contain;\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n"])));
var SideTitle = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: 20px;\n  top: 0;\n  right: 0;\n  color: ", ";\n"])), gold);
var Content = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  min-height: 450px;\n"])));
var SidePanel = (function (_ref) {
  var open = _ref.open,
    children = _ref.children,
    onClose = _ref.onClose;
  if (open) {
    document.body.classList.add("modal-open");
  } else {
    document.body.classList.remove("modal-open");
  }
  return /*#__PURE__*/React__default.createElement(Overlay, {
    open: open,
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(Side, {
    open: open
  }, /*#__PURE__*/React__default.createElement(Content, null, /*#__PURE__*/React__default.createElement(SideTitle, null, /*#__PURE__*/React__default.createElement(SideClose, {
    onClick: onClose
  })), children)));
});

export { SidePanel as default };
